// src/data/legacyPlayerImages.js
// Photos for players who were on the site before the roster moved to Firestore.
//
// These images ship with the app (imported at build time). Players added through
// the admin panel from now on store their photo in Firebase Storage instead, and
// their `imageUrl` takes priority over anything here.
//
// Keyed by player NAME to match how the old per-page imageMaps worked.

import ChrisImg from "../assets/players/ChrisWz.jpg";
import GxldenImg from "../assets/players/Gxlden.jpg";
import JrwydImg from "../assets/players/Jrwyd.jpg";
import LiquidImg from "../assets/players/Liquid.jpg";
import PetersonImg from "../assets/players/peterson.jpg";
import PotatoImg from "../assets/players/Chips.jpg";
import RvssianImg from "../assets/players/Rvssian.jpg";
import ShifuImg from "../assets/players/Shifu.jpg";
import SkrmxxImg from "../assets/players/Skrmxx.jpg";
import SlayImg from "../assets/players/Slay.jpg";
import AnnImg from "../assets/players/Ann.jpeg";
import SpltzImg from "../assets/players/Spltz.jpeg";
import GoatImg from "../assets/players/Goat.jpg";
import DuckyImg from "../assets/players/Ducky.jpg";
import LemoImg from "../assets/players/Lemo.jpg";
import TankImg from "../assets/players/Tank.jpg";
import CryptyImg from "../assets/players/Crypty.JPG";
import JesseImg from "../assets/players/Jesse.JPG";
import ChozenImg from "../assets/players/chozen.jpeg";
// Blirst was uploaded through the admin panel, but Storage download URLs turn
// out to be served to browsers only and are blocked outright by some mobile
// content blockers — so his photo ships with the app like everyone else's.
import BlirstImg from "../assets/players/Blirst.jpg";
// Skil left the active roster but returns as a Graduate — his original photo
// still ships with the app, so a graduate record named "Skil" picks it up.
import SkilImg from "../assets/players/Skil.JPG";

export const LEGACY_PLAYER_IMAGES = {
  ChrisWZ: ChrisImg,
  yyGxlden: GxldenImg,
  Jrwyd: JrwydImg,
  liquid: LiquidImg,
  XoPeterson: PetersonImg,
  Potaatochips: PotatoImg,
  DemonRvssian: RvssianImg,
  Shifu: ShifuImg,
  "The Jamaican Shifu": ShifuImg,
  Skrmxx: SkrmxxImg,
  Slay: SlayImg,
  Ann: AnnImg,
  SpltzFps: SpltzImg,
  Goat: GoatImg,
  Ducky: DuckyImg,
  Lemo: LemoImg,
  Tank5: TankImg,
  Crypty: CryptyImg,
  Jesse: JesseImg,
  Chozendontmiss: ChozenImg,
  Blirst: BlirstImg,
  Skil: SkilImg,
};

// Crop overrides for photos whose subject sits low in the frame and would
// otherwise get clipped by the square card crop.
export const LEGACY_IMAGE_POSITIONS = {
  Chozendontmiss: "center 30%",
};
